// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2bri_","additionalInfo":"AgreementModal_additionalInfo__qEo6n"};